export const DEFAULT_VALUE_PROP_NAME = 'code';
